import constants from "../constants";
import {getHeaders} from "./global";
import axios from "axios"




function updateUser(user_id, payload){
	return axios.patch(
        constants.API_URL + "users/" + user_id + "/",
        payload,
        getHeaders()
    )
}

function getUser(user_id){
	return axios.get(
        constants.API_URL + "users/" + user_id + "/",
        getHeaders()
    )
}

function upgradeUser(user_id, plan_id){
	return axios.patch(
        constants.API_URL + "users/" + user_id + "/upgrade/",
        {"plan_id": plan_id},
        getHeaders()
    )
}

function getUserAlerts(user_id){
	return axios.get(
        constants.API_URL + "users/" + user_id + "/alerts/",
        getHeaders()
    )
}

function getUserNotificationsSettings(user_id){
	return axios.get(
        constants.API_URL + "users/" + user_id + "/notifications/",
        getHeaders()
    )
}

function updateUserNotificationsSettings(user_id, payload){
	return axios.patch(
        constants.API_URL + "users/" + user_id + "/notifications/",
        payload,
        getHeaders()
    )
}


function loginUser(payload){
	return axios.post(
        constants.API_URL + "users/login/",
        payload
    )
}

export {
    getUser,
    updateUser,
    upgradeUser,
    getUserAlerts,
    getUserNotificationsSettings,
    updateUserNotificationsSettings,
    loginUser,
}
